/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".mobile-menu__item--has-items").forEach(function (item) {

    const link = item.querySelector("a[data-nav-link-mobile]");
    const toggle = item.querySelector("[data-collapsible-trigger]");

    if (!link || !toggle) return;

    link.addEventListener("click", function (e) {
      e.preventDefault(); // stop redirect
      toggle.click();    // trigger "+" behavior
    });

  });

});






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
